import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />

      {/* Page Header */}
      <section className="bg-gradient-to-r from-brand to-brand-hover text-white pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="container mx-auto px-4 lg:px-6 text-center">
          <p className="text-brand-light text-sm font-medium uppercase tracking-widest mb-3">
            Who We Are
          </p>
          <h1 className="text-3xl md:text-5xl font-semibold mb-4 leading-tight">
            A logistics partner built on trust
          </h1>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Experience, technology, and dedicated service — moving your goods with confidence.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-card shadow-card border border-gray-100 p-8 md:p-12 text-center space-y-8">
              <p className="text-xl text-dark leading-relaxed font-light">
                We are <span className="font-semibold text-brand">Metro Logistics</span> — a team of logistics
                professionals focused on making cargo movement simple and dependable.
                By combining experience, technology, and dedicated service, we help our
                customers move their goods with confidence, speed, and transparency.
              </p>

              <div className="w-16 h-0.5 bg-brand mx-auto rounded-full" />

              <p className="text-lg text-secondary leading-relaxed">
                With years of logistics experience and operational excellence, we deliver
                transport services tailored to real business needs. Our systems and skilled
                team ensure accuracy, real-time tracking, and consistent service quality
                across every shipment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
